/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * A metric broken down by one dimension (role, level, class, metro...).
 */
export interface CompanyDimensionValueSchema {
  dimension: string;
  value?: number | null;
}
